import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';
import { orgCanAccessFederation, orgCanAccessPostMatch } from '../../utils/productWorkspace';
import FederationNav from '../../components/FederationNav';
import { LoadingBlock } from './federationShared';

/**
 * Gate for Federation routes with an explicit permission-denied state.
 */
export default function FederationGate({ children }) {
  const { org, loading } = useAuth();

  if (loading) {
    return <LoadingBlock label="Checking Federation access…" />;
  }

  if (!orgCanAccessFederation(org)) {
    return (
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <h1 className="font-serif text-2xl text-navy-900 mb-3">Federation access is not enabled</h1>
        <p className="text-gray-600 mb-6">Your organization is not entitled to Tactmark Federation.</p>
        {orgCanAccessPostMatch(org) && <Link to="/dashboard" className="text-navy-900 font-medium underline">Return to Post-Match</Link>}
      </div>
    );
  }

  return (
    <>
      <FederationNav />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </div>
    </>
  );
}
